module.exports = __webpack_public_path__ + "media/pages/book/components/images/app-reviews/en/hector-1bfdba023cd67ba5e3dace395233e6f2.jpg";